import React from 'react'

function Footer() {
  return (
    <div className='footer'>
    <h4>Designed by Sushant Saud</h4>
    </div>
  )
}

export default Footer